import { render, staticRenderFns } from "./SupportLink.vue?vue&type=template&id=68a10f0e&scoped=true"
import script from "./SupportLink.vue?vue&type=script&lang=js"
export * from "./SupportLink.vue?vue&type=script&lang=js"
import style0 from "./SupportLink.vue?vue&type=style&index=0&id=68a10f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a10f0e",
  null
  
)

export default component.exports